import { ReactNode } from "react";

import { css } from "@compiled/react";

import Form from "@atlaskit/form";

import { useSiteActivationContext } from "../../hooks/site-activation-context";
import { SiteNameInput as DefaultSiteNameInput } from "../common/site-name-input";

import { HelperText as DefaultHelperText } from "./helper-text";
import { NewUserSubmitButton as DefaultSubmitButton } from "./submit-button";

export const Content = ({
    SiteNameInput = <DefaultSiteNameInput />,
    HelperText = <DefaultHelperText />,
    SubmitButton,
    PrivacyPolicy = null
}: {
    SiteNameInput?: ReactNode;
    HelperText?: ReactNode;
    SubmitButton?: ReactNode;
    PrivacyPolicy?: ReactNode;
}) => {
    const { activateSite } = useSiteActivationContext();

    const activateSiteWithPrivacyPolicy = () => {
        const privacyPolicy =
            document.getElementById("privacy-policy-text")?.innerHTML || "";
        activateSite({ privacyPolicy });
    };

    if (SubmitButton === undefined) {
        SubmitButton = (
            <DefaultSubmitButton hasPrivacyPolicy={!!PrivacyPolicy} />
        );
    }

    return (
        <Form onSubmit={activateSiteWithPrivacyPolicy} isDisabled={false}>
            {({ formProps }) => (
                <form
                    {...formProps}
                    autoComplete="off"
                    css={containerCss}
                    data-testid="new-user-site-activation"
                >
                    <div>
                        {SiteNameInput}
                        {HelperText}
                    </div>
                    {SubmitButton}
                    <div id="privacy-policy-text">{PrivacyPolicy}</div>
                </form>
            )}
        </Form>
    );
};

const containerCss = css({
    display: "grid",
    gap: "24px"
});
